import { NameList } from 'components/common/NameList';
import { Box } from '@chakra-ui/react';
import { CellProps, ClassListCellProps } from '../types/Cell';

export const ClassListCell = (props: CellProps): JSX.Element | null => {
  const { classes, maxVisible = 1 } = props as ClassListCellProps;

  if (!classes || classes.length === 0) {
    return null;
  }
  const nameOfClasses = classes.map((c) => c.name) ?? [];
  return (
    <Box position="relative" p="0 10px 0 0">
      <NameList names={nameOfClasses} maxVisible={maxVisible} />
    </Box>
  );
};
